import React, { Component } from 'react';

import { inject } from 'mobx-react';

import DoceboEnrollment from './DoceboEnrollment';

class PurchaseSuccessKabbalahone extends Component {
	
	handleClick = event => {
		event.preventDefault();		
		this.props.shopStore.cashsale.set(null);
		window.location.href = '/';		
	}

	render() {
		const { orderNumber, total } = this.props;	
		const { docebo } = this.props.shopStore	
		return (
			<div className="container">
				<div className="row">
					<div className="col-md-12 text-center">
						<div className="alert alert-success" role="alert">
							Success!							
						</div>
						{!docebo.get('enroll') && 
							<span>
								<p>
									Your pre-order has been processed successfully. Be on the lookout for your 
									pre-paid invite from care@kabbalahone.com in January.
								</p>
								<p>
									Your order number is {orderNumber}. Your order total is USD ${total}.
								</p>
							</span>
						}
						{docebo.get('enroll') &&
							<p>
								Thank you for your order. Your order number is {orderNumber} totalling
								USD ${total}. You should receive a welcome email within a few minutes. 
								<br />
								<span className="small text-muted">
									Please whitelist care@kabbalahone.com to be sure that you are 
									receiving all notifications. 
								</span>
							</p>							
						}
					</div>
				</div>
				<hr />
				{!docebo.get('enroll') && 
					<div className="row">
						<div className="col-md-12 text-center">
							<h5>
								<small className='text-muted'>Kabbalah One makes a wonderful gift.</small><br />					
								<a href="" onClick={this.handleClick}>
									Buy one for a friend!
								</a>
							</h5>
						</div>
					</div>	
				}
				{docebo.get('enroll') && 		
					<div className="row">
						<div className="col-md-12">
							<DoceboEnrollment />
						</div>
					</div>
				}			  
			</div>
		);
	}
};

export default inject('shopStore')(PurchaseSuccessKabbalahone);


// WEBPACK FOOTER //
// ./src/components/PurchaseSuccessKabbalahone.js